import { MantineThemeOverride } from '@mantine/core';

export type LoadingOverlayTheme = NonNullable<MantineThemeOverride['components']>['LoadingOverlay'];

export const LoadingOverlay: LoadingOverlayTheme = {
  // todo: define
};
